import { render, staticRenderFns } from "./vesupplierList.vue?vue&type=template&id=6a44e672&"
import script from "./vesupplierList.vue?vue&type=script&lang=js&"
export * from "./vesupplierList.vue?vue&type=script&lang=js&"
import style0 from "./vesupplierList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports